import React, { useEffect, useState, useRef } from "react";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
import { dataUserSession, ipAddressSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//Page
import P200Overview from "./P200Overview";
import P200List from "./P200List";
//CSS
import "../../../components/DataTable/DataTable.css";
//SERVICE
import { P200Dashboard, P200GetDataList } from "../../../service/200/P200Service";
import { formatDateAPI } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P200() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);

    //Dashboard
    const [dataDashboard, setDataDashboard] = useState({
        overdueOrder: "",
        pendingInspectRequest: "",
        pendingOrder: "",
        totalAmount: "",
        totalContract: "",
        totalLength: "",
        waitingApproveReport: "",
        waitingApproveRequest: "",
    });
    const [sentDashBoard, setSentDashBoard] = useState({
        mode: "U",
        sessionId: ipAddressSession() ? ipAddressSession().sessionId : "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    //DataTable
    const [dataTable, setDataTable] = useState([]);
    const [searchData, setSearchData] = useState({
        inquireMode: "A",
        contractNo: "",
        contractorName: "",
        requestDateBegin: "",
        requestDateEnd: "",
        requestStatus: "",
        requestType: "",
        searchWord: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state && history.location.state.dataSrh ? history.location.state.dataSrh : ""),
    });

    const [loading, setLoading] = useState(false);
    const [loadingRefresh, setLoadingRefresh] = useState(true);
    const [countTimer, setcountTimer] = useState(30);

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP200Dashboard();
        onP200GetDataList();
    }, [sentDashBoard, searchData]); //searchData

    useEffect(() => {
        let count = 30;
        const interval = setInterval(() => {
            // sentDashBoard.mode ='A'
            let newReq = {
                ...sentDashBoard,
                mode: "A",
            };

            if (count === 1) {
                onP200Dashboard(newReq);
                count = 30;
                setcountTimer(30);
            } else {
                count = count - 1;
                setcountTimer(count);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [searchData, sentDashBoard]);

    const onRefreshClick = () => {
        setSentDashBoard({
            ...sentDashBoard,
            mode: "A",
        });
        setcountTimer(30);
    };

    const onP200Dashboard = (newReq) => {
        newReq = newReq ? newReq : sentDashBoard;
        setLoadingRefresh(true);
        P200Dashboard(newReq).then(
            (res) => {
                setLoadingRefresh(false);
                if (res !== undefined) {
                    if (res[0]) {
                        setDataDashboard(res[0]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoadingRefresh(false);
                setErrData(err);
            }
        );
    };

    const onP200GetDataList = () => {
        let dataSrh = {
            ...searchData,
            requestDateBegin: searchData.requestDateBegin !== "" ? formatDateAPI(searchData.requestDateBegin, false) : "",
            requestDateEnd: searchData.requestDateEnd !== "" ? formatDateAPI(searchData.requestDateEnd, false) : "",
        };
        // console.log(dataSrh);
        P200GetDataList(dataSrh).then(
            (res) => {
                // console.log('res ',res);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onClickSrhOnDashBoard = (status) => {
        setSearchData({
            ...searchData,
            requestStatus: status,
        });
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const goPage = (data) => {
        if (data.functionId === "207" || data.functionId === "201") {
            history.push({
                pathname: data.functionId,
                state: { requestTypeDesc: data.requestTypeDesc, requestNo: data.requestNo, contractNo: data.contractNo, routeName: data.routeName, action: "EDIT" },
            });

            // new 14/02/2022
        } else if (data.functionId === "260") {
            history.push({
                pathname: data.functionId,
                state: {
                    requestNo: data.requestNo,
                },
            });
        } else {
            history.push({
                pathname: data.functionId,
                state: { requestNo: data.requestNo, action: "EDIT" },
            });
        }
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            {/* <div className="p-grid crud-demo"> */}
            <Toast ref={toast} position="top-right" />
            {/* <Chip label={" ผู้คุมงาน : " + fullName} icon="pi pi-user" className="p-mr-2 p-mb-2" style={{ fontSize: "1.2rem" }} /> */}
            <br />
            <div style={{ display: "flex", justifyContent: "center" }}>
                <P200Overview
                    dataDashboard={dataDashboard}
                    onClickSrhOnDashBoard={onClickSrhOnDashBoard}
                    countTimer={countTimer}
                    onRefreshClick={onRefreshClick}
                    loadingRefresh={loadingRefresh}
                    // onClickPendingRequest = {onClickPendingRequest}
                    //searchData={searchData} setSearchData={setSearchData} onSearch={() => onADM01GetDataList()}
                />
            </div>
            <br />
            <div className="card">
                <P200List dataTable={dataTable} searchData={searchData} goPage={goPage} setLoading={setLoading} setErrData={setErrData} showMessages={showMessages} userId={dataUserSession() ? dataUserSession().userId : ""}/>
            </div>
            {/* </div> */}
        </>
    );
}
